import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Role, Utilisateur } from "../../types";

export default function ListeUtilisateurs() {
  const [utilisateurs, setUtilisateurs] = useState<Utilisateur[]>([]);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.role !== "ADMIN") {
      navigate("/"); // redirige vers l'accueil si pas admin
    }
  }, [user, navigate]);

  useEffect(() => {
    if (user?.role === "ADMIN") {
      fetch(`${process.env.REACT_APP_API_USER_URL}/api/users`)
        .then((res) => res.json())
        .then((data) =>
          setUtilisateurs(
            data.map((u: any) => ({
              id: u.id,
              pseudo: u.pseudo,
              role: u.role as Role,
            }))
          )
        );
    }
  }, [user]);

  const modifierRole = async (id: number, nouveauRole: Role) => {
    await fetch(`${process.env.REACT_APP_API_USER_URL}/api/users/${id}/role`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ role: nouveauRole }),
    });
    setUtilisateurs((u) =>
      u.map((user) =>
        user.id === id ? { ...user, role: nouveauRole } : user
      )
    );
  };

  const supprimer = async (id: number) => {
    await fetch(`${process.env.REACT_APP_API_USER_URL}/api/users/${id}`, {
      method: "DELETE",
    });
    setUtilisateurs((u) => u.filter((user) => user.id !== id));
  };

  return (
    <div className="admin-container">
      <h2>Gestion des utilisateurs</h2>
      <table className="admin-table">
        <thead>
          <tr>
            <th>Pseudo</th>
            <th>Rôle</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {utilisateurs.map((u) => (
  <tr key={u.id}>
    <td>{u.pseudo}</td>
    <td>{u.role}</td>
    <td>
      <button
        onClick={() =>
          modifierRole(u.id, u.role === "USER" ? "ADMIN" : "USER")
        }
        disabled={u.id === user.id} // facultatif, si tu veux aussi bloquer le changement de rôle
      >
        Changer rôle
      </button>

      {/* Masquer le bouton Supprimer si c'est l'utilisateur connecté */}
      {u.id !== user.id && (
        <button onClick={() => supprimer(u.id)}>Supprimer</button>
      )}
    </td>
  </tr>
))}
        </tbody>
      </table>
    </div>
  );
}